import { FC } from "react";
import { FaEdit, FaTimes } from "react-icons/fa";
import { Formater, TypeRecords } from "src/framework/commons";
import { CartaoCreditoParcelaType, CartaoType } from "src/types";
import "./styles.scss"

interface CardCartaoCreditoProperties {
    cartao: CartaoType & { parcela?: CartaoCreditoParcelaType | null }
    disableEdit?: boolean;
    onEdit: () => void;
    onRemove: () => void;
}

const CardCartaoCredito: FC<CardCartaoCreditoProperties> = ({
    cartao,
    disableEdit = false,
    onEdit,
    onRemove
}) => {
    return <div className="CardCartaoCredito">
        <div className={`credit-card ${cartao.bandeira} selectable`}>
            <div className="edit">
                {!disableEdit && <FaEdit className="icon-edit"
                    onClick={() => {
                        onEdit();
                    }}
                />}
                <FaTimes className="icon-remove"
                    onClick={() => {
                        onRemove();
                    }}
                />
            </div>
            <div className="credit-card-last4">
                {cartao.numero.slice(-4)}
            </div>
            <div className="info">

                <div className="nome">
                    {String(cartao.nome).toUpperCase()}
                </div>

                <div className="valor-parcela">
                    {Formater.toString(cartao.valor_original, TypeRecords.CURRENCY)} em {cartao.parcelas}x {Formater.toString(cartao.valor_parcela, TypeRecords.CURRENCY)}
                </div>
            </div>
            <div className="credit-card-expiry">
                {cartao.mes_expiracao}/{String(cartao.ano_expiracao).slice(-2)} <div className="cvv">{cartao.cvv}</div>
            </div>
        </div>
    </div>
}

export { CardCartaoCredito }